"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeFeedback = exports.changeFormat = exports.generatem = exports.generate = exports.init = exports.fireTest = void 0;
var FC = require("../firebase/fire_constants");
var fire_test_1 = require("../firebase/fire_test");
var BT = require("../generate/braille_transformer");
var buttons_1 = require("./buttons");
var LU = require("./local_util");
var transformers = new Map([
    ['NABT', new BT.Nabt2Unicode()],
    ['BLDT', new BT.Bldt2Unicode()],
    ['SDF/JKL', new BT.Ascii2Braille('', '')],
    ['1-6', new BT.Numeric2Braille('', '')]
]);
var backtransformers = new Map([
    ['NABT', new BT.Unicode2Nabt()],
    ['BLDT', new BT.Unicode2Bldt()],
    ['SDF/JKL', new BT.Braille2Ascii('', '')],
    ['1-6', new BT.Braille2Numeric('', '')]
]);
var kind = 'NABT';
function transformer() {
    return transformers.get(kind.toUpperCase());
}
function backtransformer() {
    return backtransformers.get(kind.toUpperCase());
}
var field = {};
exports.fireTest = null;
var current = '';
function setTest(test) {
    field.name.innerHTML = test.name;
    field.expression.innerHTML = test.input ?
        "<math display=\"block\">" + test.input + "</math>" : (test.tex ? "\\[" + test.tex + "\\]" : "" + test.name);
    field.out.innerHTML = test.expected;
    field.ip.value =
        backtransformer().via(test.expected);
    field.ip.focus();
    setReferences(test.reference);
    setStatus(test[FC.Interaction]);
    setFeedback(test[FC.FeedbackStatus]);
    if (MathJax.typeset) {
        MathJax.typeset();
    }
    buttons_1.updateAccess();
}
function setReferences(references) {
    var e_1, _a, _b;
    field.refname.innerHTML = '';
    field.references.innerHTML = '';
    if (!references) {
        return;
    }
    var keys = Object.keys(references).sort(function (x, y) {
        var numX = parseInt(x.split('-')[1], 10);
        var numY = parseInt(y.split('-')[1], 10);
        return numX < numY ? -1 : (numX > numY ? 1 : 0);
    });
    var size = keys.length;
    if (!size) {
        return;
    }
    field.refname.innerHTML = 'References:';
    var links = [];
    var makeRef = size > 10 ? optionReference : linkReference;
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var id = keys_1_1.value;
            var url = references[id];
            links.push(makeRef(id, url));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (size <= 10) {
        (_b = field.references).append.apply(_b, __spread(links));
        return;
    }
    var select = document.createElement('select');
    select.setAttribute('onChange', 'window.open(this.value, "_blank")');
    select.classList.add('access');
    var option = document.createElement('option');
    option.setAttribute('disabled', '');
    option.setAttribute('selected', '');
    option.textContent = 'Select:';
    select.appendChild(option);
    select.append.apply(select, __spread(links));
    field.references.appendChild(select);
}
function linkReference(id, url) {
    var link = document.createElement('a');
    link.classList.add('reflink');
    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
    link.textContent = id;
    return link;
}
function optionReference(id, url) {
    var option = document.createElement('option');
    option.classList.add('access');
    option.textContent = id;
    option.value = url;
    return option;
}
function setFeedback(feedback) {
    if (feedback !== undefined) {
        field.feedback.value = feedback.toString();
    }
}
function setStatus(status) {
    if (status !== undefined) {
        switch (status) {
            case 0:
                field.statuscolor.className = 'green';
                field.statusvalue.innerHTML = 'New';
                break;
            case 1:
                field.statuscolor.className = 'yellow';
                field.statusvalue.innerHTML = 'Viewed';
                break;
            case 2:
                field.statuscolor.className = 'red';
                field.statusvalue.innerHTML = 'Changed';
                break;
            default:
                field.statuscolor.className = '';
                field.statusvalue.innerHTML = '';
        }
    }
}
function getTest() {
    return { expected: field.out.innerHTML };
}
function initConversion(collection, file) {
    if (firebase) {
        initFile(collection, file);
        return;
    }
    setTimeout(initConversion, 100);
}
function init() {
    var path = LU.getStorage(FC.NemethProjectPath);
    var user = LU.getStorage(FC.NemethProjectUser);
    if (path && user) {
        initConversion(user, path);
    }
}
exports.init = init;
function initFile(collection, file) {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    db = firebase.app().firestore();
                    exports.fireTest = new fire_test_1.FireTest(db, collection, file, getTest, setTest);
                    return [4, exports.fireTest.prepareTests()];
                case 1:
                    _a.sent();
                    field.ip = document.getElementById('input');
                    field.out = document.getElementById('braille');
                    field.error = document.getElementById('error');
                    field.format = document.getElementById('format');
                    field.expression = document.getElementById('mathexpression');
                    field.name = document.getElementById('mathname');
                    field.statuscolor = document.getElementById('statuscolor');
                    field.statusvalue = document.getElementById('statusvalue');
                    field.feedback = document.getElementById('feedback');
                    field.refname = document.getElementById('refname');
                    field.references = document.getElementById('references');
                    buttons_1.init(exports.fireTest);
                    exports.fireTest.setTest(exports.fireTest.currentTest());
                    return [2];
            }
        });
    });
}
function translate(str) {
    var _a = __read(transformer().cleanInput(str), 2), input = _a[0], error = _a[1];
    return [input, transformer().via(input), error];
}
function generate() {
    var ip = field.ip;
    if (current === ip.value) {
        return;
    }
    if (kind.toUpperCase() === 'SDF/JKL') {
        collateKeys();
    }
    processKeys();
}
exports.generate = generate;
var collating = false;
function collateKeys() {
    if (collating) {
        return;
    }
    collating = true;
    setTimeout(function () {
        collating = false;
        processKeys();
        var ip = field.ip;
        if (ip.value[ip.value.length - 1] !== ',') {
            ip.value = ip.value + ',';
        }
    }, 100);
}
function processKeys() {
    var ip = field.ip;
    var cursor = ip.selectionStart;
    field.out.innerHTML = '';
    field.error.innerHTML = '';
    var _a = __read(translate(ip.value), 3), input = _a[0], output = _a[1], error = _a[2];
    if (error) {
        field.error.innerHTML = 'Unknown ' +
            (error.length > 1 ? 'elements ' : 'element ') + error;
    }
    if (input !== current) {
        setStatus(2);
    }
    ip.value = input;
    current = input;
    field.out.innerHTML = output;
    ip.selectionEnd = cursor - error.length;
}
function generatem() {
    setTimeout(generate, 100);
}
exports.generatem = generatem;
function changeFormat() {
    exports.fireTest.saveTest(exports.fireTest.getTest());
    kind = field.format.value;
    exports.fireTest.setTest(exports.fireTest.currentTest());
}
exports.changeFormat = changeFormat;
function changeFeedback() {
    var value = parseInt(field.feedback.value, 10);
    exports.fireTest.currentTest()[FC.FeedbackStatus] = value;
    exports.fireTest.saveFeedback(value);
}
exports.changeFeedback = changeFeedback;
